import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import lodashGet from 'lodash/get';
import { memo } from 'react';
import { RemoveAssignmentsButton, removeAssignmentCssStyle, } from '../../../elements/RemoveAssignmentsButton';
function SignalAssignmentsColumn({ row, onHover, assignment, highlight, onLink, onUnlink, }) {
    const diaIDs = lodashGet(row, 'tableMetaInfo.signal.diaIDs', []);
    const tdCss = assignment.isActive || highlight.isActive
        ? {
            color: 'red',
            fontWeight: 'bold',
        }
        : {};
    function assignHandler(e) {
        onLink?.(e, assignment);
    }
    return (_jsx("td", { ...onHover, onClick: assignHandler, style: { padding: '0', ...tdCss }, css: !assignment.isActive && removeAssignmentCssStyle, children: (diaIDs?.length > 0 || assignment.isActive) && (_jsxs(_Fragment, { children: [_jsx("span", { children: diaIDs?.length || 0 }), _jsx(RemoveAssignmentsButton, { onClick: (e) => onUnlink?.(e, false) })] })) }));
}
export default memo(SignalAssignmentsColumn);
